import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  Section,
  ImageBox,
  HeroBlurb,
  Box,
  Text,
  Elevation,
  Icon,
  Heading,
  TextField,
  Avatar,
  Button,
  PageContentWrapWithSideBar,
  List,
  ListItem,
  ListItemText,
  ListItemPrimaryText,
  ListItemSecondaryText,
  ListItemGraphic,
  ListGroup,
  ListItemMeta,
  ListDivider,
  Page,
  Image
} from "../theme";
import { SideBar } from "../Components/SideBar/SideBar";
import { data } from "../data";
import { map } from "lodash";
import PeoplePic from "../assets/_MG_0887.jpg";
import avtr from "../assets/_MG_0511.JPG";
const StyledTab = styled.button`
  background-color: ${props => (props.active ? "green" : "red")};
`;

export const Person = ({ name, text, path, image }) => (
  <Link
    to={path}
    style={{ color: "#555", width: "100%", textDecoration: "none" }}
  >
    <List twoLine avatarList>
      <ListGroup>
        <ListItem style={{ borderBottom: "1px solid gray" }}>
          <ListItemGraphic
            icon={
              <Box size={48}>
                <Image
                  height="100%"
                  borderRadius="100%"
                  bg="secondary"
                  src={image}
                  objectFit="contain"
                  opjectPosition="center top"
                />
              </Box>
            }
          />
          <ListItemText>
            <ListItemPrimaryText>{name}</ListItemPrimaryText>
            <ListItemSecondaryText>Areas of Practice</ListItemSecondaryText>
          </ListItemText>
          <ListItemMeta>
            <Box>
              <Icon px={1} icon="email" />
              <Icon px={1} icon="phone" />
              <Icon px={1} icon="info" />
            </Box>
          </ListItemMeta>
        </ListItem>
      </ListGroup>
    </List>
  </Link>
);

const People = props => {
  const { Attorneys } = data;
  return (
    <Page>
      <ImageBox useFilter="true" width={1} bgImage={PeoplePic}>
        <HeroBlurb heading="People" image={PeoplePic} color="secondaryLight" />
      </ImageBox>
      <PageContentWrapWithSideBar
        aboutTitle="About Our People"
        aboutText="The attorneys at Egerton McAfee are the firm's greatest asset.
              They offer a wealth of expertise from their collective practical
              experience, yet always look for ways to innovate, ensuring their
              clients receive the most effective representation possible.
              Moreover, the firm places a high premium on professionalism,
              integrity, and placing its client's interests before its own.
              Egerton, McAfee's close–knit team of attorneys is just that–a
              team–and each one considers the ability to ask another for his
              or her advice both a privilege and a well–utilized benefit."
      >
        <Section bg="secondaryLight" width={1}>
          <Box my={4} width={1} display="flex" justifyContent="center">
            <TextField
              width={[3 / 4, null, 1 / 3]}
              outlined
              icon="search"
              trailingIcon="close"
              label="search"
              trailingIcon={{
                icon: "close",
                tabIndex: 0,
                onClick: () => console.log("Clear")
              }}
            />
          </Box>

          <Box width="85%">
            {map(Attorneys, (v, k) => (
              <Person
                key={k}
                name={v.name}
                image={v.image}
                text={v.email}
                path={v.profile_url}
              />
            ))}
          </Box>
        </Section>
      </PageContentWrapWithSideBar>
    </Page>
  );
};

export default People;
